import $ from 'jquery';

window.$ = window.jQuery = $;

// Export for use in modules
export default $;